// extracted by mini-css-extract-plugin
export default {"card_container":"Card_card_container__Gth30"};